import { AvatarDropdown, AvatarName, SelectVersion, Footer, Question } from '@/components';
import { DownOutlined } from '@ant-design/icons';
import type { Settings as LayoutSettings, MenuDataItem } from '@ant-design/pro-components';
import { SettingDrawer } from '@ant-design/pro-components';
import type { RunTimeLayoutConfig } from '@umijs/max';
import { history, Link } from '@umijs/max';
import React from 'react';
import defaultSettings, { themes } from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';
import DynamicMenuLinks from '@/components/DynamicMenuLinks';  //菜单下面的动态菜单
import filterMenuByAccess from './utils/filterMenuByAccess'
// import baseRoutes from '../config/baseRoutes';
import { fetchUserMenu, fetchProductMenu } from '@/services';
import MyIcon from '@/utils/iconfont';
import {USER_KEY,ACCESS_TOKEN_KEY} from '@/utils/constants';
const isDev = process.env.NODE_ENV === 'development';
const loginPath = '/user/login';
import routes from '../config/routes'; 
import _ from 'lodash';
/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  menuData?: MenuDataItem[] | undefined; // 动态路由方案2
  loading?: boolean;
  currentTenantId?: number; // Added currentTenantId to the initial state
}> {
  // 从 localStorage 获取用户信息
  const currentUser = JSON.parse(localStorage.getItem(USER_KEY) || '{}');
  const token = sessionStorage.getItem(ACCESS_TOKEN_KEY);
  // 读取用户保存的主题；若未保存，则使用部署配置的默认主题（defaultSettings.defaultTheme）
  const defaultTheme = (defaultSettings as any).defaultTheme || 'blue';
  const savedTheme = localStorage.getItem('app-theme') || defaultTheme;
  const theme = themes[savedTheme] || themes[defaultTheme] || themes.blue;
  // 应用 CSS 变量（顶部导航、侧边栏等自定义颜色），刷新后恢复
  if (typeof document !== 'undefined') {
    const root = document.documentElement;
    Object.entries(theme.cssVars || {}).forEach(([k, v]) =>
      root.style.setProperty(k, v)
    );
  }
  const settings = theme as Partial<LayoutSettings>;
  // 如果不是登录页面，执行
  const { location } = history;
  if (location.pathname !== loginPath) {

    // 获取用户菜单-动态路由 TODO:用户路由接口提供后取消注释
    // const { data } = await fetchUserMenu();
    // // 动态路由方案1
    // const menuData = data;
    // extraRoutes = menuData;


    return {
      // fetchUserInfo,
      currentUser,
      // menuData, //TODO:用户路由接口提供后取消注释
      settings,
      currentTenantId: undefined, // Default value for currentTenantId
    };
  }
  return {
    // fetchUserInfo,
    currentUser,
    // menuData: [], //TODO:用户路由接口提供后取消注释
    settings,
    currentTenantId: undefined, // Default value for currentTenantId
  };
}




// 封装遍历路由的方法
// const getAllPaths = (routesArray: MenuDataItem[] = []) => {
//   const paths: MenuDataItem[] = [];
//   routesArray?.forEach(item => {
//     paths.push(item.path);
//     if (item.routes) {
//       item.routes.forEach(route => {
//         paths.push(route.path);
//       });
//     }
//   });
//   return paths;
// };


//在初始加载和路由切换时出发 -路由保护   TODO:用户路由接口提供后取消注释
// export function onRouteChange({ location, routes, action }) {
  // // 将 routes 对象转换为数组


  // // 获取所有路径(extraRoutes：用户接口返回的路由)-菜单模块不含子页
  // // const menuPaths = extraRoutes?.map(item => item.path) || [];

  // // extraRoutes：用户接口返回的路由
  // // 获取动态路由和基础路由的所有路径
  // const dynamicPaths = getAllPaths(extraRoutes); // 动态路由包含子页面
  // const basePaths = getAllPaths(baseRoutes); // 基础路由（跳转用）

  // // 合并所有路径=routes.ts的配置
  // const allPaths = [ ...dynamicPaths, ...basePaths];

  // // 判断当前路径是否在菜单路径中
  // if (!allPaths.includes(location.pathname)) {
  //   console.log(allPaths,location.pathname,'路由不满足情况');
  //   history.push('/404');
  //   return null;
  // }
// }




export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  return {
    logo: defaultSettings.base + 'logo.png',
    // // 动态菜单
    menuDataRender:()=>{
      const { teamList } = initialState?.currentUser || {};

      const currentTenantId = initialState?.currentTenantId || 0;  
      let roles=['person'];
      if (currentTenantId > 0 && Array.isArray(teamList)) {
        for (let i=0;i<teamList.length;i++){
          const tenantRole=teamList[i];
          if(tenantRole.id==currentTenantId){
             roles=tenantRole.roles;
             break;
          }
        }
      }

      // 使用 fixMenuItemIcon 处理菜单图标和权限过滤
      const filteredMenus = filterMenuByAccess(routes, roles);

      return filteredMenus;
    },
    // 自定义左侧下方区域内容
    menuExtraRender: () => <DynamicMenuLinks />,
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        // return (
        //   <>此处放选择个人版<AvatarDropdown><MyIcon type="icon-yonghu-01" />{avatarChildren}</AvatarDropdown></>
        // );
        return (
          <>
          {/* 个人空间/租户/团队下拉菜单 */}
            <SelectVersion />
            {/* 账号下拉/个人设置菜单 */}
            <AvatarDropdown menu={true}>
              <div>
                <MyIcon type="icon-yonghu-01" />
                {avatarChildren}
                <DownOutlined style={{ marginLeft: '10px' }} />
              </div>
            </AvatarDropdown>
          </>
        );
      },
    },
    waterMarkProps: {
      content: initialState?.currentUser?.displayName,
    },
    // footerRender: () => <div className='footer'>Copyright © 2020-2024 沈阳东软智能医疗科技研究院有限公司</div>,
    onPageChange: () => {
      // 判断缓存中有无token和用户信息是否存在功能放在 requestErrorConfig.ts 中
    },
    bgLayoutImgList: [],
    // links: isDev
    //   ? [
    //       <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
    //         <LinkOutlined />
    //         <span>OpenAPI 文档</span>
    //       </Link>,
    //     ]
    //   : [],
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      return (
        <>
          {children}
          </>
      );
    },
    ...initialState?.settings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...errorConfig,
};
